/* Primal Edge cart drawer (replaces UpCart, 2026-10-22).
   - Watches every cart write on the page (fetch, XHR, plain form posts) so the theme, GemPages and Kaching bundles all open it.
   - Re-renders through the Section Rendering API (sections/pe-cart.liquid), so prices and discounts always come from Shopify.
   - Takes over the theme's own cart-drawer / cart-notification so only one cart ever shows. */
(function (w, d) {
  if (w.PECart) return;
  var SECTION = 'pe-cart', BUBBLE = 'cart-icon-bubble';
  var nativeFetch = w.fetch.bind(w);
  var root = null, lastFocus = null, timer = null, wantOpen = false, queue = Promise.resolve();
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;

  function el(html) { var t = d.createElement('template'); t.innerHTML = html.trim(); return t.content; }

  function mount() {
    if (root) return root;
    root = d.createElement('div');
    root.className = 'pe-cart';
    root.id = 'pe-cart';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Cart');
    root.innerHTML = '<div class="pe-cart__backdrop" data-pe-cart-close></div><div class="pe-cart__panel"></div>';
    var tpl = d.getElementById('pe-cart-tpl');
    if (tpl) root.querySelector('.pe-cart__panel').appendChild(tpl.content.cloneNode(true));
    d.body.appendChild(root);
    root.addEventListener('click', onClick);
    root.addEventListener('change', onInput);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-pe-qty-input]')) { e.preventDefault(); e.target.blur(); }
    });
    return root;
  }

  function open() {
    mount();
    if (root.classList.contains('is-open')) return;
    lastFocus = d.activeElement;
    root.classList.add('is-open');
    d.documentElement.classList.add('pe-cart-lock');
    var c = root.querySelector('.pe-cart__close');
    if (c) setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) {} }, 50);
    emit('pe:cart:open');
  }

  function close() {
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    d.documentElement.classList.remove('pe-cart-lock');
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    emit('pe:cart:close');
  }

  function emit(name, detail) { try { d.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {} }

  function paint(sections) {
    mount();
    var html = sections && sections[SECTION];
    if (html) {
      var frag = el(html), inner = frag.querySelector('.pe-cart__inner');
      if (inner) {
        var panel = root.querySelector('.pe-cart__panel'), body = panel.querySelector('.pe-cart__body');
        var top = body ? body.scrollTop : 0;
        panel.innerHTML = '';
        panel.appendChild(inner);
        var nb = panel.querySelector('.pe-cart__body');
        if (nb) nb.scrollTop = top;
        var n = parseInt(inner.getAttribute('data-pe-cart-count'), 10) || 0;
        d.querySelectorAll('[data-pe-cart-count-badge]').forEach(function (b) { b.textContent = n; });
      }
    }
    var bub = sections && sections[BUBBLE], target = d.getElementById('cart-icon-bubble');
    if (bub && target) {
      var f = el(bub), src = f.querySelector('.shopify-section') || f.firstElementChild;
      if (src) target.innerHTML = src.innerHTML;
    }
    emit('pe:cart:updated');
  }

  function sectionsUrl() {
    var r = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
    return r + '?sections=' + SECTION + ',' + BUBBLE + '&_=' + Date.now();
  }

  function refresh() {
    queue = queue.then(function () {
      return nativeFetch(sectionsUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(paint)
        .catch(function () {});
    });
    return queue;
  }

  // Something else wrote to the cart: gather bursts (Kaching adds a bundle in a few calls) into one refresh.
  function schedule(openAfter) {
    if (openAfter) wantOpen = true;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var o = wantOpen; wantOpen = false;
      refresh().then(function () { if (o) open(); });
    }, 120);
  }

  function change(key, qty) {
    mount();
    root.classList.add('is-busy');
    queue = queue.then(function () {
      return nativeFetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty), sections: [SECTION, BUBBLE], sections_url: w.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (res.ok && res.j.sections) { paint(res.j.sections); emit('pe:cart:changed', { key: key, quantity: qty }); }
          else return nativeFetch(sectionsUrl(), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(paint);
        })
        .catch(function () {})
        .then(function () { root.classList.remove('is-busy'); });
    });
    return queue;
  }

  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-pe-cart-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-pe-qty]');
    if (q) {
      e.preventDefault();
      var item = q.closest('[data-key]');
      if (item) change(item.getAttribute('data-key'), parseInt(q.getAttribute('data-pe-qty'), 10) || 0);
      return;
    }
    if (t.closest('[data-pe-checkout]')) emit('pe:cart:checkout');
  }

  function onInput(e) {
    if (!e.target.matches('[data-pe-qty-input]')) return;
    var item = e.target.closest('[data-key]'), v = parseInt(e.target.value, 10);
    if (item && !isNaN(v)) change(item.getAttribute('data-key'), v);
  }

  // ---- Watch cart writes made by the theme and apps ----
  function urlOf(input) { try { return typeof input === 'string' ? input : (input && input.url) || String(input); } catch (e) { return ''; } }

  w.fetch = function (input, init) {
    var p = nativeFetch.apply(w, arguments), u = urlOf(input);
    if (CART_WRITE.test(u)) {
      p.then(function (r) { if (r && r.ok) schedule(/\/cart\/add/.test(u)); }).catch(function () {});
    }
    return p;
  };

  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__peUrl = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this, u = String(x.__peUrl || '');
    if (CART_WRITE.test(u)) {
      x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) schedule(/\/cart\/add/.test(u)); });
    }
    return xs.apply(this, arguments);
  };

  // Plain product forms nobody else handles: add over ajax instead of leaving for /cart.
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f || !f.action || !/\/cart\/add/.test(f.action)) return;
    e.preventDefault();
    nativeFetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (r.ok) schedule(true); else f.submit(); })
      .catch(function () { f.submit(); });
  });

  // Cart icons and "/cart" links open the drawer instead of the cart page.
  d.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || (root && root.contains(a))) return;
    var h;
    try { h = new URL(a.href, w.location.href); } catch (x) { return; }
    if (h.origin === w.location.origin && /^\/cart\/?$/.test(h.pathname) && !h.search) {
      e.preventDefault();
      e.stopPropagation();
      open();
    }
  }, true);

  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // The theme's drawer and notification: route their open/render calls here.
  function takeOver(tag) {
    if (!w.customElements) return;
    w.customElements.whenDefined(tag).then(function () {
      var C = w.customElements.get(tag);
      if (!C || C.prototype.__pe) return;
      C.prototype.__pe = true;
      C.prototype.open = function () { schedule(true); };
      C.prototype.renderContents = function () { schedule(true); };
      if ('getSectionsToRender' in C.prototype) {
        C.prototype.getSectionsToRender = function () { return [{ id: BUBBLE }]; };
      }
    });
  }
  takeOver('cart-drawer');
  takeOver('cart-notification');

  // Some templates (beer-belly, product-2) render <cart-drawer> but never load cart-drawer.js, so the theme's
  // product-form finds a bare element and crashes on this.cart.getSectionsToRender. Give every cart element the
  // calls product-form makes. With no cart element at all product-form sends shoppers to /cart, so add a stub.
  function shimCarts() {
    if (!d.querySelector('cart-drawer, cart-notification')) {
      var stub = d.createElement('cart-drawer');
      stub.setAttribute('data-pe-stub', '');
      stub.hidden = true;
      d.body.appendChild(stub);
    }
    d.querySelectorAll('cart-drawer, cart-notification').forEach(function (c) {
      if (typeof c.getSectionsToRender !== 'function') c.getSectionsToRender = function () { return [{ id: BUBBLE }]; };
      if (typeof c.setActiveElement !== 'function') c.setActiveElement = function () {};
      if (typeof c.renderContents !== 'function') c.renderContents = function () { schedule(true); };
      if (typeof c.open !== 'function') c.open = function () { schedule(true); };
    });
  }

  // Old UpCart hooks some scripts still call.
  w.upcartOpenCart = w.upcartOpenCart || open;
  w.upcartCloseCart = w.upcartCloseCart || close;
  w.upcartRefreshCart = w.upcartRefreshCart || refresh;

  d.documentElement.classList.add('pe-cart-on');
  function boot() { shimCarts(); mount(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();

  // bfcache: coming back from checkout must show the real cart, not a stale one.
  w.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  w.PECart = { open: open, close: close, refresh: refresh, change: change };
})(window, document);
